/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { MDDEResult } from "@sa/rep-mdde";
import { useDictionary, useOLAPTransformer, yearToCropYearFull, OLAPTransformerResult } from "../../../shared";
import { dataService, dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe } from "../../../../charts/pipes";

const CATEGORIES_AXIS = "calendar.default";
const SERIES_AXIS = "commodities.default";

export function useData2(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, categories] = useDictionary(dictionaryService, "calendar-gi");
  const [, series] = useDictionary(dictionaryService, "commodities-gi");
  const options = useMemo(() => {
    if (!olapResult || !categories) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsDictionaries: new Map([
        [CATEGORIES_AXIS, categories],
      ]) as ReadonlyMap<string, Dictionary>
    }
  }, [olapResult, categories]);
  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${CATEGORIES_AXIS}.name`],
      rows: [],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [`${CATEGORIES_AXIS}.name`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
